import { makeOffer as _makeOffer } from 'src/thirdweb/dotc'
import { transferCredits } from 'src/thirdweb/verified_carbon_credits'
import useCarbonNftContract from './useCarbonNftContract'
import useSmartAccount from 'src/common/api-clients/safe-protocol-kit/useSmartAccount'
import useOwnedCarbonTokens from 'src/common/apollo/hooks/useOwnedCarbonTokens'
import { useCallback } from 'react'

const useTransferCarbonNfts = () => {
  const { smartAccountInfo } = useSmartAccount()
  const { ownedCarbonTokens, total } = useOwnedCarbonTokens(
    smartAccountInfo?.address
  )
  const maxTransfer = Math.max(total, 100)
  const contract = useCarbonNftContract()

  const transferNfts = useCallback(
    ({
      to,
      amount,
      tokenIds = [],
    }: {
      to: string
      amount: number
      tokenIds?: (number | string)[]
    }) => {
      if (!contract) return

      const transferNftsTx = transferCredits({
        contract,
        tokenIds:
          tokenIds.length > 0
            ? tokenIds.map(t => BigInt(t))
            : ownedCarbonTokens.slice(0, amount).map(t => BigInt(t.tokenId)),
        transferTo: to,
      })

      return transferNftsTx
    },
    [contract, ownedCarbonTokens]
  )

  return {
    transferNfts,
  }
}

export default useTransferCarbonNfts
